import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

export default function Footer() {
  const { t } = useTranslation();
  const { lang = 'en' } = useParams<{ lang: string }>();

  const footerLinks = [
    {
      title: 'Resources',
      links: [
        { label: t('nav.spreadsheet'), href: `/${lang}/spreadsheet/` },
        { label: t('nav.categories'), href: `/${lang}/categories/` },
        { label: t('nav.guides'), href: `/${lang}/guides/` },
        { label: t('nav.reviews'), href: `/${lang}/review/` },
      ],
    },
    {
      title: 'Support',
      links: [
        { label: t('nav.shipping'), href: `/${lang}/shipping/` },
        { label: t('nav.safety'), href: `/${lang}/safety/` },
        { label: t('nav.faq'), href: `/${lang}/faq/` },
        { label: t('footer.contact'), href: `/${lang}/contact/` },
      ],
    },
    {
      title: 'Legal',
      links: [
        { label: t('footer.about'), href: `/${lang}/about/` },
        { label: t('footer.privacy'), href: `/${lang}/privacy/` },
        { label: t('footer.terms'), href: `/${lang}/terms/` },
        { label: t('footer.disclaimer'), href: `/${lang}/disclaimer/` },
      ],
    },
  ];

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="container-main section-padding">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          {/* Brand Column */}
          <div className="sm:col-span-2 lg:col-span-1">
            <a href={`/${lang}/`} className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-table-2 text-white text-lg"></i>
              </div>
              <span className="font-heading font-bold text-lg text-foreground-950">
                AllChinaBuy
              </span>
            </a>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              {t('footer.description')}
            </p>
            <p className="text-xs text-foreground-500 italic">
              {t('footer.notAffiliated')}
            </p>
          </div>

          {/* Link Columns */}
          {footerLinks.map((column) => (
            <div key={column.title}>
              <h3 className="font-heading font-semibold text-foreground-900 mb-4">
                {column.title}
              </h3>
              <ul className="space-y-2.5">
                {column.links.map((link) => (
                  <li key={link.href}>
                    <a
                      href={link.href}
                      className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-foreground-500">
            © {new Date().getFullYear()} allchinabuyspread.cyou. {t('footer.copyright')}
          </p>
          <div className="flex items-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors"
            >
              kaspreadsheet.com
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}